import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bankingOdder'
})
export class BankingOdderPipe implements PipeTransform {

  transform(topics: any, term: any): any {
    if (!Array.isArray(topics)) return [];
    let filteredTopics = !term || typeof term !== 'string' 
      ? topics 
      : topics.filter(topic => topic.name.toLowerCase().includes(term.toLowerCase()));
    const uniqueTopics = filteredTopics.filter((topic, index, self) => 
      index === self.findIndex(t => t.name === topic.name)
    );
    return uniqueTopics.sort((a, b) => a.name.localeCompare(b.name));
  }

}
